<template>
  <div class="share-on-job">
    <div class="s-btn btn-blue btn-lg is-plain" @click="handleShare">分享给顾客</div>
    <!-- 分享给顾客 -->
    <common-share-wxa-dialog
      :visible.sync="shareModalShow"
      title="分享给顾客"
      page="subpackage/pages/on-job/edit-on-job/edit-on-job"
      :scene="`id=${jobInfo.archives_onjob_id}&a=${User.peer_account_id}`"
      methods-one-title="扫描二维码后分享给顾客"
      step-two-title="点击分享给好友"
      step-two-img="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/on-job/share-img.gif"
      methods-two-tips="复制链接并发送给顾客，顾客可在微信上直接打开填写在职证明"
      page-from="在职证明编辑页"
    ></common-share-wxa-dialog>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import CommonShareWxaDialog from '../../../components/common/share/common-share-wxa-dialog.vue';
import User from '../../../libs/user';

export default {
  components: {
    CommonShareWxaDialog,
  },
  props: {
    jobInfo: {
      type: Object,
      default() {
        return {};
      },

    },
  },
  data() {
    return {
      User,
      shareModalShow: false,
    };
  },
  computed: {},
  created() {},
  methods: {
    handleShare() {
      sensorsdata.track('On_the_job_resend', {
        page_from: '在职证明详情',
      });
      this.shareModalShow = true;
    },
  },
};
</script>

<style lang="less" scoped>
.share-on-job{
  .s-btn{
    padding: 0 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/on-job/components/share-on-job.vue